import { VirtualTourViewerMode } from "store/atoms/currentVirtualViewerMode";

export const vTourViewModes: {
  name: VirtualTourViewerMode;
  method: string;
  gameObject: string;
}[] = [
  {
    name: "Orbit",
    method: "SetViewModeDollhouse",
    gameObject: "Main Camera",
  },
  {
    name: "Floorplan",
    method: "SetViewModeFloorPlan",
    gameObject: "Main Camera",
  },
  {
    name: "VirtualTour",
    method: "SetViewModeVirtualTour",
    gameObject: "Main Camera",
  },
];
